module.exports = __webpack_public_path__ + "img/NG.342d5ddb.svg";